import React from "react";
import SectionContactUS from "./SectionContactUS";

const SectionSeo: React.FC = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What sizes of sink couplings does Devi Plastic manufacture?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Devi Plastic manufactures sink couplings in standard sizes such as 3 inch and 4 inch, including heavy, lite, jumbo, and royal variants.",
        },
      },
      {
        "@type": "Question",
        name: "Is Devi Plastic a sink coupling manufacturer or trader?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Devi Plastic is a manufacturer of sink couplings and plastic drainage fittings with in-house die making and quality control.",
        },
      },
      {
        "@type": "Question",
        name: "Where is Devi Plastic located?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Devi Plastic is located in Ahmedabad, Gujarat, India and supplies sink couplings across India.",
        },
      },
      {
        "@type": "Question",
        name: "Do you supply sink couplings in bulk?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, Devi Plastic supplies sink couplings in bulk for wholesalers, distributors, and project requirements across India.",
        },
      },
    ],
  };

  return (
    <section aria-labelledby="seo-section-heading" className="w-full pb-5 ">
      {/* INNER WRAPPER */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="">
          {/* HEADING */}
          <h2
            id="seo-section-heading"
            className="text-2xl text-primary-500 sm:text-2xl md:text-3xl lg:text-4xl font-semibold "
          >
            Premium Sink Coupling Manufacturer in India
          </h2>

          {/* DESCRIPTION */}
          <p className="mt-6 text-base sm:text-base md:text-lg leading-relaxed text-slate-700 max-w-4xl">
            <strong>Devi Plastic</strong> is a trusted
            <strong> sink coupling manufacturer</strong> based in
            <strong> Ahmedabad, Gujarat</strong>. We manufacture durable and
            leak-resistant <strong>sink waste couplings</strong> for kitchen and
            bathroom drainage systems, suitable for residential, commercial, and
            industrial applications across India.
          </p>

          {/* WHY CHOOSE */}
          <h3 className="mt-12 text-lg sm:text-xl md:text-2xl font-semibold text-slate-900">
            Why Choose Devi Plastic?
          </h3>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 text-base sm:text-base md:text-lg text-slate-700">
            {[
              "Premium plastic materials with long service life",
              'Available in standard 3" and 4" sizes',
              "Heavy, lite, jumbo & royal coupling options",
              "In-house die making & strict quality control",
              "Bulk supply & distributor support",
              "Pan-India delivery network",
            ].map((text, i) => (
              <div key={i} className="flex items-start gap-3">
                <span className="text-primary-500 font-bold text-base sm:text-lg">
                  ✓
                </span>
                <span>{text}</span>
              </div>
            ))}
          </div>

          {/* FAQ */}
          <SectionContactUS />
          <h3 className="mt-14 text-lg sm:text-xl md:text-2xl font-semibold text-slate-900">
            Frequently Asked Questions
          </h3>

          <div className="mt-6 space-y-4 ">
            {faqSchema.mainEntity.map((faq, index) => (
              <details
                key={index}
                className="group border border-gray-200 rounded-xl p-5 bg-gray-50"
              >
                <summary className="cursor-pointer font-medium text-slate-800 flex justify-between items-center text-base sm:text-lg">
                  {faq.name}
                  <span className="ml-1 text-primary-500 group-open:rotate-180 transition-transform">
                    ▼
                  </span>
                </summary>
                <p className="mt-4 text-slate-700 text-base sm:text-base">
                  {faq.acceptedAnswer.text}
                </p>
              </details>
            ))}
          </div>
        </div>
      </div>

      {/* FAQ SCHEMA */}
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </section>
  );
};

export default SectionSeo;
